
import * as React from 'react'

const SvgComponent = ({
    ...props
}: React.SVGProps<SVGSVGElement>) => {
    const w = 30
    const h = 30
    return (
        <svg width={w} height={h} viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg"  {...props}>
            <path d="M12.8625 4.82452L2.27497 22.4995C2.05668 22.8776 1.94117 23.3061 1.93995 23.7427C1.93873 24.1792 2.05183 24.6084 2.268 24.9877C2.48417 25.3669 2.79587 25.683 3.1721 25.9043C3.54833 26.1257 3.97596 26.2447 4.41247 26.2495H25.5875C26.024 26.2447 26.4516 26.1257 26.8278 25.9043C27.2041 25.683 27.5158 25.3669 27.7319 24.9877C27.9481 24.6084 28.0612 24.1792 28.06 23.7427C28.0588 23.3061 27.9433 22.8776 27.725 22.4995L17.1375 4.82452C16.9146 4.45716 16.6009 4.15342 16.2265 3.94263C15.8521 3.73183 15.4296 3.62109 15 3.62109C14.5703 3.62109 14.1479 3.73183 13.7735 3.94263C13.3991 4.15342 13.0853 4.45716 12.8625 4.82452V4.82452Z" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M15 11.25V16.25" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M15 21.25H15.0125" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    )
}

export default SvgComponent
